import React, { useEffect, useRef } from "react";
import { Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import FiveProgressBars from "../../../../components/common/FiveProgressBars";

export default function Result_1_Promotion({
  version = "promotion",
}: {
  version?: string; // v5...
}) {
  const navigate = useNavigate();

  const pageKey = "result_1";

  const handleNext = () => {
    navigate(`/${version}-onboarding/result/2`);
  };

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {});

  return (
    <Stack
      sx={{
        width: "100%",
        mx: "auto",
      }}
      justifyContent="center"
    >
      <Stack
        spacing={"60px"}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            textAlign: "center",
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {"답변을 분석하고 있습니다.\n" + "프로그램이 곧 준비됩니다."}
        </CustomTypography>
        <FiveProgressBars handleNext={handleNext} />
        <CustomTypography
          variant={"Caption"}
          fontWeight={500}
          sx={{
            textAlign: "center",
            color: theme.vars.palette.Content.Medium,
          }}
        >
          {
            "잠시만 기다려주세요. 이미 성공을 경험한\n디스턴싱 유저들의 데이터 포인트 40만 개에 기반해\n내게 꼭 맞는 프로그램을 구성하고 있습니다."
          }
        </CustomTypography>
      </Stack>
    </Stack>
  );
}
